import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useNavigate, useMatch } from 'react-router-dom';

const ConnectTabs: React.FC = () => {
  const navigate = useNavigate();
  const match = useMatch('/connect/:section/*');
  const activeKey = match?.params.section;

  const handleTabClick = (key: string) => {
    navigate({ pathname: `/connect/${key}`, search: '' });
  };

  const items: TabsProps['items'] = [
    {
      key: 'config',
      label: 'Config',
    },
    {
      key: 'sharing',
      label: 'Sharing',
    },
  ];

  return (
    <div className="flex justify-end w-full">
      <Tabs
        tabPosition="left"
        onTabClick={handleTabClick}
        activeKey={activeKey}
        items={items}
        className="[&_.ant-tabs-content-holder]:hidden"
      />
    </div>
  );
};

export default ConnectTabs;
